// extracted by mini-css-extract-plugin
export default {"errorsList":"lbRBXGjUxe9mBn5UHlLu","error":"mituJdF5ia31Yae5Nm4g","errorCross":"pHQKkvjsngkqkAqJpkhq"};